import { render, staticRenderFns } from "./ChatAnswerBar.vue?vue&type=template&id=4ae482d7&scoped=true"
import script from "./ChatAnswerBar.vue?vue&type=script&lang=js"
export * from "./ChatAnswerBar.vue?vue&type=script&lang=js"
import style0 from "./ChatAnswerBar.vue?vue&type=style&index=0&id=4ae482d7&prod&lang=scss"
import style1 from "./ChatAnswerBar.vue?vue&type=style&index=1&id=4ae482d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae482d7",
  null
  
)

export default component.exports